module.exports = __webpack_public_path__ + "img/industry_line.42166686.png";